/**
@description 设置路由路径
*/
import error404 from './error404'
export const errorRouting = [
  {
    path: '404',
    component:error404,
    name: 'error404',
    // indexRoute: {
    //   name: '404',
    //   catname: 'loanApply',
    //   component: SinglePageFaq
    // }
  }
]



// WEBPACK FOOTER //
// ./modules/404/routing.js